module.exports = __webpack_public_path__ + "static/media/seriesIconDetail.b77f68d7.svg";